import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {addToGlobalStyles, addToWizard} from '../../store/actions';
import colors from '../../util/colors';
import * as fonts from '../../util/fonts';
import {Icons} from '../../util/icons';
import {strings} from '../../util/strings';
import AppButton from '../app-button';
import Icon from '../icon';
import {Column, Row} from '../layout';
import ModalTemplate from '../modal';
import './styles.scss';

interface RequestPopupPreAuthorizationProps {
  user: any;
  addToGlobalStyles(value: any): void;
  selectedBu: any;
  labels: typeof strings.pt.preAuthorizations;
  show: boolean;
  setShowModal(value: any): void;
  addToWizard(value: any): void;
  onSubmit(value: any): void;
  title: string;
  list: any;
  onClose?(): void;
  titleOfButton: string;
  buStyles: any;
  defaultValue?: string;
}

function DocumentPopup({
  user,
  addToGlobalStyles,
  selectedBu,
  labels,
  addToWizard,
  show,
  setShowModal,
  onSubmit,
  title,
  list,
  onClose,
  titleOfButton,
  buStyles,
  defaultValue,
}: RequestPopupPreAuthorizationProps) {
  const [finalValue, setFinalValue] = useState<string>(defaultValue || '');
  const [finalItem, setFinalItem] = useState<any>([]);
  const [hover, setHover] = useState();

  const auxFinalValue = (value: string) => {
    if (finalValue === value) {
      setFinalValue('');
    } else {
      setFinalValue(value);
    }
  };

  const isEqual = (finalValue: any, elem: {label: any; value: any}) => {
    return finalValue === elem.label || finalValue == elem.value;
  };
  return (
    <Column
      className="pre-autorizacoes-modal-content p-5"
      style={!show ? {display: 'none'} : {}}>
      <ModalTemplate
        className="p-5"
        show={show}
        onHide={() => {
          if (onClose) {
            onClose();
          }
          setShowModal(false);
          setFinalValue('');
        }}
        cross={true}
        hideFooter={true}>
        <Column>
          <Row className="pre-autorizacoes-title-row">
            <p
              style={{...fonts.L, ...fonts.SemiBold, color: colors.black}}
              className="p-preautorizacoes">
              {title}
            </p>
          </Row>
          <Row className="pre-autorizacoes-table-row">
            <table
              className="table table-hover pl-3 pr-3"
              onMouseOut={() => setHover(undefined)}>
              <tbody>
                {list.map((elem: any) => (
                  <tr
                    key={elem.label}
                    id={elem.label}
                    onClick={(e) => {
                      auxFinalValue(elem.label);
                      setFinalItem(elem);
                    }}
                    onMouseOver={() => {
                      setHover(elem.value);
                    }}
                    style={{
                      backgroundColor:
                        isEqual(finalValue, elem) || elem.value === hover
                          ? (buStyles?.primaryColor || colors.blue)?.concat(
                              '1A'
                            )
                          : 'transparent',
                    }}>
                    <td align="left" id={elem.label}>
                      <span
                        id={elem.label}
                        style={{
                          ...fonts.MM,
                          ...fonts.Medium,
                          color: colors.black,
                        }}
                        className="p-preautorizacoes">
                        {elem.label}
                      </span>
                    </td>
                    <td className="pre-authorization-checkbox" id={elem.label}>
                      {isEqual(finalValue, elem) ? (
                        <Icon
                          name={Icons.CHECK}
                          width="14"
                          height="19.44"
                          changeViewbox
                          viewBox={'0 0 24 24'}
                          color={colors.black}
                        />
                      ) : (
                        <div></div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Row>
          <div className="submit-button-divider"></div>
          <Row>
            <AppButton
              disabled={finalValue === ''}
              className="pre-autorizacoes-buttons"
              style={{...fonts.M, color: colors.white}}
              onClick={() => {
                onSubmit(finalValue);
                setFinalValue('');
                setShowModal(false);
                addToWizard({
                  selectedValue: finalValue,
                  selectedItem: finalItem,
                });
              }}>
              {titleOfButton}
            </AppButton>
          </Row>
        </Column>
      </ModalTemplate>
    </Column>
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  strings,
  wizard,
  globalStyles,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: strings.value.pt.authorization,
  wizard: wizard.value,
  buStyles: globalStyles.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(DocumentPopup)
);
